import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ProductLocationPopup } from './CompetitorProductLocationPopup';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
    Button,
    Chip,
    Autocomplete,
    TextField
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const category_images = {
    "Appetizers & Sides": "f4d162babed3adfbc07921679d84d368.png",
    "Burgers": "7990f92cc9e91087bfa36af0fb64d05a.png",
    "Sandwiches & Wraps": "c8c405f19b567b18d6a53e646529ec05.png",
    "Pizzas": "26202dabbbc256097dd558e61f5163c5.png",
    "Pastas": "f7d284c34b0fa07b791ca3f2e6a9dbcf.png",
    "Salads": "69c7ea267011b736da7e600ae0205cf1.png",
    "Soups & Stews": "fa78151e8761a93e868f72fc770a093b.png",
    "Seafood": "d9b38b5bed15bc6eea6935e32c22da58.png",
    "Chicken Dishes": "45e8036e6494825439c7c785ef41e1dd.png",
    "Beef Dishes": "8d5ed041b019e011bd10f5aff7b2fc56.png",
    "Pork Dishes": "a27599bc1b82ac86a891bb05c8da5c19.png",
    "Vegetarian & Vegan": "2da59f1cc661a341d6add1c526755075.png",
    "Vegan": "71a731effc43ac8bab7455c5e4ce9cc5.png",
    "Breakfast & Brunch": "71881a4d1971eb4ba6986261a49e0173.png",
    "Egg Dishes": "1f91f534f2d181089e07b7cb93c0bdda.png",
    "Rice Bowls": "cbb26e76391afbcd71a9cbccc9720be8.png",
    "Noodles": "785b95b3572eb0ac40598fbc7a8e12e4.png",
    "Tacos & Burritos": "6b7ccfc6e4ab64f5412bc8ff5057994a.png",
    "Quesadillas": "029c93b90d51ab369a7d29aed9f2b193.png",
    "Nachos": "9b173701e7f489098d6622b7cb43194a.png",
    "BBQ & Grilled Meats": "d767d393cdeb3f90ce42cd99c2f61760.png",
    "Fried Foods": "b8a8b30849a94c4036dd5ab1d4d6c316.png",
    "Bakery & Pastries": "b8964c91ab2804954aa4b3ca97c85c09.png",
    "Desserts": "66ea83dd5375f75118335d2b82e2fb29.png",
    "Ice Cream & Frozen Treats": "a5ca25b5d1babf39c7a25a2ef7d97834.png",
    "Combo Food": "4d52446038e423b5bee64af2ad8bd6ef.png",
    "Sauces": "815bbeaca8e0456f0cf50cd003507e53.png",
    "Beverages - Hot": "640819e4e75a4ef82ef6871e9e52f9fa.png",
    "Beverages - Cold": "0ec36c9f4edc68cdac549a8ff64ba480.png",
    "Smoothies & Shakes": "65c5b81ea265af25b080e93199bfa6c5.png",
    "Alcoholic Drinks": "f50daf8c97a0d6f751e83b6dbb2489de.png",
    "Kids Menu": "3b20b6ff86e1439f1e423ce40c811751.png",
    "Combo Meals": "d05e8c3ed994e77e677c276a419c1fb1.png",
    "Specialty Items": "bea40633d81970b07ad714e8d3f53ccf.png"
  }

export const CompetitorProductOverview = ({ topLineClass, products, website }) => {
    console.log('Product Overview: ', products)
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [popupOpen, setPopupOpen] = useState(false);
    const [expandedProducts, setExpandedProducts] = useState({});
    const [selectedCategories, setSelectedCategories] = useState([]);
    
    // Get unique categories and initialize all as selected
    const allCategories = [...new Set(products.map(product => product.category || product.clean_category).filter(Boolean))];
    
    useEffect(() => {
        setSelectedCategories(allCategories);
    }, [products]);



    const formatPrice = (priceData) => {
        if (!priceData) return 'Price not available';
        
        // Handle clean_price object format
        if (typeof priceData === 'object') {
            if (priceData.min && priceData.max) {
                return `$${priceData.min.toFixed(2)} - $${priceData.max.toFixed(2)}`;
            } else if (priceData.price) {
                return `$${priceData.price.toFixed(2)}`;
            }
        }
        
        // Handle legacy format
        return typeof priceData === 'number' ? `$${priceData.toFixed(2)}` : priceData;
    };

    const handleProductClick = (product) => {
        setSelectedProduct(product);
        setPopupOpen(true);
    };

    const handleClosePopup = () => {
        setPopupOpen(false);
        setSelectedProduct(null);
    };

    const handleProductToggle = (productIndex) => {
        setExpandedProducts(prev => ({
            ...prev,
            [productIndex]: !prev[productIndex]
        }));
    };

    
    // handleCategoryChange is now handled directly in Autocomplete onChange
    
    // Filter products based on selected categories
    const filteredProducts = products.filter(product => {
        const productCategory = product.category || product.clean_category;
        return selectedCategories.includes(productCategory);
    });

    if (loading) {
        return (
            <div className={topLineClass}>
                <div className="Competitor-loading">Loading Products...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className={topLineClass}>
                <div className="Competitor-error">{error}</div>
            </div>
        );
    }

    if (!products || products.length === 0) {
        return null;
    }

    return (
        <div className={topLineClass}>
            <div className='box-container Competitor-market-segment'>
                {/* <div className="Competitor-financials-title">Product Overview</div> */}
                
                {/* Category Filter */}
                <Box sx={{ mb: 3, display: 'flex', justifyContent: 'flex-start' }}>
                    <Autocomplete
                        multiple
                        options={allCategories}
                        value={selectedCategories}
                        onChange={(event, newValue) => {
                            setSelectedCategories(newValue);
                        }}
                        renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                            ))
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Filter Categories"
                                placeholder="Select categories"
                            />
                        )}
                        sx={{ minWidth: 300 }}
                    />
                </Box>
                
                <Box sx={{ width: '100%' }}>
                    {filteredProducts.map((product, productIndex) => (
                        product.variations && typeof product.variations === 'object' && Object.keys(product.variations).length > 0 ? (
                            <Accordion 
                                key={productIndex}
                                expanded={expandedProducts[productIndex] || false}
                                onChange={() => handleProductToggle(productIndex)}
                                sx={{ mb: 1, boxShadow: 'none', border: '1px solid #E9EAEB' }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    sx={{ backgroundColor: '', minHeight: '56px' }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, width: '100%', pl: 2 }}>
                                        <Typography 
                                            variant="h6" 
                                            sx={{ 
                                                fontWeight: 600, 
                                                color: '#1976d2',
                                                cursor: 'pointer',
                                                '&:hover': { textDecoration: 'underline' }
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleProductClick(product);
                                            }}
                                        >
                                            {product.name || 'Product Name Not Available'}
                                        </Typography>
                                        
                                        <Chip 
                                            label={product.category || product.clean_category || 'N/A'} 
                                            size="small" 
                                            color="primary" 
                                            variant="outlined"
                                        />
                                        
                                        <Typography variant="body1" color="primary" sx={{ fontWeight: 600, ml: 'auto', pr: 1 }}>
                                            {formatPrice(product.clean_price)}
                                        </Typography>
                                    </Box>
                                </AccordionSummary>
                                
                                <AccordionDetails sx={{ pt: 0, pb: 1 }}>
                                {/* Product Description */}
                                {product.description && (
                                    <Box sx={{ mb: 2, p: 2, pl: 2, borderRadius: 1, textAlign: 'left' }}>
                                        <Typography variant="subtitle2" gutterBottom sx={{ textAlign: 'left' }}>
                                            Product Description:
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'left', pl: 2 }}>
                                            {product.description}
                                        </Typography>
                                    </Box>
                                )}
                                
                                {/* Variations Section */}
                                {product.variations ? (
                                    <Box>
                                        <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                                            Product Variations ({Object.keys(product.variations).length})
                                        </Typography>
                                        
                                        {Object.entries(product.variations).map(([variationName, price], variationIndex) => (
                                            <Box 
                                                key={variationIndex}
                                                sx={{ 
                                                    display: 'flex', 
                                                    justifyContent: 'space-between', 
                                                    alignItems: 'center',
                                                    p: 2,
                                                    mb: 1,
                                                    backgroundColor: '#f9f9f9',
                                                    border: '1px solid #e0e0e0',
                                                    borderRadius: 1
                                                }}
                                            >
                                                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                    {variationName}
                                                </Typography>
                                                
                                                <Typography 
                                                    variant="body1" 
                                                    color={price ? "primary" : "text.secondary"} 
                                                    sx={{ fontWeight: 600 }}
                                                >
                                                    {price ? formatPrice(price) : "Not Available"}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                ) : (
                                    <Box sx={{ p: 2, textAlign: 'center', backgroundColor: '#f9f9f9', borderRadius: 1 }}>
                                        <Typography variant="body2" color="text.secondary">
                                            No variations available for this product.
                                        </Typography>
                                    </Box>
                                )}
                                </AccordionDetails>
                            </Accordion>
                        ) : (
                            // Simple row for products without variations
                            <Box 
                                key={productIndex}
                                sx={{ 
                                    mb: 1, 
                                    p: 2, 
                                    border: '1px solid #e0e0e0', 
                                    borderRadius: 1,
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, pl: 2 }}>
                                    <Typography 
                                        variant="h6" 
                                        sx={{ 
                                            fontWeight: 600, 
                                            color: '#1976d2',
                                            cursor: 'pointer',
                                            '&:hover': { textDecoration: 'underline' }
                                        }}
                                        onClick={() => handleProductClick(product)}
                                    >
                                        {product.name || 'Product Name Not Available'}
                                    </Typography>
                                    
                                    <Chip 
                                        label={product.category || product.clean_category || 'N/A'} 
                                        size="small" 
                                        color="primary" 
                                        variant="outlined"
                                    />
                                    
                                    <Typography variant="body1" color="primary" sx={{ fontWeight: 600, ml: 'auto', pr: 4 }}>
                                        {formatPrice(product.clean_price)}
                                    </Typography>
                                </Box>
                                
                                {/* Product Description for non-expandable items */}
                                {product.description && (
                                    <Box sx={{ mt: 2, pl: 2, textAlign: 'left' }}>
                                        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'left' }}>
                                            {product.description}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        )
                    ))}
                </Box>
            </div>
            <ProductLocationPopup 
                open={popupOpen}
                onClose={handleClosePopup}
                product={selectedProduct}
                category_images={category_images}
                website={website}
            />
        </div>
    );
};